import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject, Mixins, Prop } from 'vue-property-decorator';
import draggable from 'vuedraggable'
import { SectionMixin } from '@/courses/mixins/section.mixin';
import { FixedSection } from '@/sections/types/sections.types';
import { Section } from '@/courses/models/section.model';
import { ContentType } from '@/content/types/content.types';
import { SectionProvider } from '@/sections/providers/section.provider';
import { SECTION_TYPES } from '@/content/values/sections';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';

@Component({
  components: {
    draggable,
    EdSection: () => import(/* EdSection */'@/courses/components/ed-section/ed-section.vue'),
  }
})
class EdSectionTreeComponent extends Mixins(SectionMixin, CourseToolsMixin) {
  @Inject() EduacAppSetLoading;

  @Prop({ default: true }) readonly canPullSections: boolean;
  @Prop() readonly className: string;
  @Prop({ default: null }) readonly parentId: number;
  @Prop() readonly isProject: boolean;
  @Prop({ default: 'SUBJECT' }) readonly contentType: ContentType;
  @Prop({ default: () => [] }) readonly sections: Section[];
  @Prop() readonly contentId: number;
  @Prop({ default: null }) readonly fixedSection: FixedSection;

  get isTemplate(): boolean {
    return this.contentType === 'TEMPLATE';
  } 

  get sectionsFiltered() {
    return this.sections.filter(
      s => s.fixedSection !== 'FUN' && s.fixedSection !== 'FILLERS' && s.fixedSection !== 'ADDITIONAL'
    );
  }
  
  get group() {
    let name = 'FOLDER_BRANCH';
    let putFn = (to, from) => this.canPullSections;

    if (this.isTemplate) {
      name = 'FOLDER_LESSON_BRANCH';
      putFn = (to, from) => {
        const section: Section = from.el.__vue__.context.element;
        if(section && section.type === SECTION_TYPES.SECTION.code && !section.fixedSection) {
          return SectionProvider.getIfFolderCanHaveObjects(section.sections);
        }
      }
    }

    return { 
      name,
      put: putFn 
    };
  }
  
  onSectionAdded(e: any) {
    const section: Section = { ...e.item._underlying_vm_ };

    let place = -1;

    if (e.newIndex === 0) {
      place = -1;
    } else if (this.sections[e.newIndex]) {
      if (this.sections[e.newIndex].sectionId === section.id) {
        place = this.sections[e.newIndex - 1].id;
      } else {
        place = this.sections[e.newIndex].sectionId;
      }
    }

    // section.parentId = this.parentId;
    this.verifyMovement(section, place, e.oldIndex);
  }

  async onSectionMoved(e) {
    this.$Courses.Store.setMovingObject(false);
    this.verifyMovement(
      e.item._underlying_vm_,
      e.newIndex == 0 ? -1 : this.sections[(e.newIndex - 1)] ? this.sections[(e.newIndex - 1)].sectionId : this.sections[e.newIndex].sectionId,
      e.oldIndex,
    );
  }

  async verifyMovement(sectionToMove: Section, place: number, oldIndex: number) {
    this.$Courses.Store.setMovingObject(false);
    if(this.isTemplate) {
      SectionProvider.confirmSectionMoveInTemplate(
        sectionToMove,
        oldIndex,
        this.sectionsFiltered,
        this.parentId
      ).then(async ({ modalUsed }) => {
        if (modalUsed) {
          this.EduacAppSetLoading(true);
        }

        await this.runReorder(sectionToMove, place);
      }).finally(() => {
        this.EduacAppSetLoading(false);
      });
    } else {
      await this.runReorder(sectionToMove, place);
    }
  }

  async runReorder(section: Section, place: number, realParentId = null) {
    await this.$Courses.Store.reorderSectionA({
      section,
      parentId: this.parentId,
      place,
      courseId: this.contentId
    });
    await this.getContentForCourse({ 
      courseId: this.contentId,
      classId: this.classId
    });
  }

}

export default Vue.component('ed-section-tree', EdSectionTreeComponent)
